import { isQuestion } from "../../../../../../components/Questionnaire/Section/Question/types";
import type { VisibilityMap } from "../../../../../../components/Questionnaire/validation/form/types";
import type { Answers, QuestionnaireState } from "../../../../types";

type ApplyAddressLookupUpdatesArgs = {
  groupNames: string[];
  answers: Answers;
  visibility: VisibilityMap;
  serverVisibleByName: Record<string, boolean>;
  state: QuestionnaireState;
};

export const applyAddressLookupUpdates = ({
  groupNames,
  answers,
  visibility,
  serverVisibleByName,
  state,
}: ApplyAddressLookupUpdatesArgs): {
  answers: Answers;
  visibility: VisibilityMap;
} => {
  const nextAnswers = { ...answers };
  const nextVisibility = { ...visibility };

  groupNames.forEach(name => {
    const hasAnswer = nextAnswers[name] !== undefined;
    const visible = serverVisibleByName[name];
    const q = state.sections[state.currentSectionIndex].questions
      .filter(isQuestion)
      .find(q => q.name === name);
    nextVisibility[name] = hasAnswer && visible && !q?.hiddenOnAutocomplete;
  });

  // We only need to handle the address group visibility here, the answers are managed in mergeAnswers
  return { answers: nextAnswers, visibility: nextVisibility };
};
